const FrameIndexPage = resolve => require(['../layouts/main.layout.vue'], resolve)

const HomePage = resolve => require(['../pages/home/views/home.page.vue'], resolve)

const ChangePwdPage = resolve => require(['../pages/home/views/change-pwd.page.vue'], resolve)

const GradeListPage = resolve => require(['../pages/grade/views/grade-list.page.vue'], resolve)

const GradeCreatePage = resolve => require(['../pages/grade/views/grade-create.page.vue'], resolve)

const GradeEditPage = resolve => require(['../pages/grade/views/grade-edit.page.vue'], resolve)

const SemesterListPage = resolve => require(['../pages/semester/views/semester-list.page.vue'], resolve)

const SemesterEditPage = resolve => require(['../pages/semester/views/semester-edit.page.vue'], resolve)

const CodeListPage = resolve => require(['../pages/code/views/code-list.page.vue'], resolve)

const CodeCreatePage = resolve => require(['../pages/code/views/code-create.page.vue'], resolve)

const AddressListPage = resolve => require(['../pages/address/views/address-list.page.vue'], resolve)

// const EventListPage = resolve => require(['../pages/event/views/event-list.page.vue'], resolve)

const TestPage = resolve => require(['../pages/event/views/test_order.vue'], resolve)

const EventRegListPage = resolve => require(['../pages/event/views/event-reg-list.page.vue'], resolve)

const exporListPage = resolve => require(['../pages/export/views/export-list.page.vue'], resolve)

const TeacherListPage = resolve => require(['../pages/teacher/views/teacher-list.page.vue'], resolve)

const TeacherEditPage = resolve => require(['../pages/teacher/views/teacher-edit.page.vue'], resolve)

const CourseListPage = resolve => require(['../pages/course/views/course-list.page.vue'], resolve)

const CourseEditPage = resolve => require(['../pages/course/views/course-edit.page.vue'], resolve)

const CourseCreatePage = resolve => require(['../pages/course/views/course-create.page.vue'], resolve)

const CourseWorkListPage = resolve => require(['../pages/course/views/coursework-list.page.vue'], resolve)

const StudentListPage = resolve => require(['../pages/student/views/student-list.page.vue'], resolve)

const StaffListPage = resolve => require(['../pages/staff/views/staff-list.page.vue'], resolve)

const ExperiencerListPage = resolve => require(['../pages/experiencer/views/experiencer-list.page.vue'], resolve)

const TrusteeListPage = resolve => require(['../pages/trustee/views/trustee-list.page.vue'], resolve)

const LecturerListPage = resolve => require(['../pages/lecturer/views/lecturer-list.page.vue'], resolve)

const StudentCreatePage = resolve => require(['../pages/student/views/student-create.page.vue'], resolve)

const StudentSelectCoursePage = resolve => require(['../pages/student/views/student-select-course.page.vue'], resolve)

const SemesterSelectStudentPage = resolve => require(['../pages/semester/views/semester-select-student.page.vue'], resolve)

const CreditSelectStudentPage = resolve => require(['../pages/semester/views/credit-select-student.page.vue'], resolve)

const StudentShowPage = resolve => require(['../pages/student/views/student-show.page.vue'], resolve)

const NewsListPage = resolve => require(['../pages/news/views/news-list.page.vue'], resolve)

const NewsCreatePage = resolve => require(['../pages/news/views/news-create.page.vue'], resolve)

const NewsEditPage = resolve => require(['../pages/news/views/news-edit.page.vue'], resolve)

const ApplyListPage = resolve => require(['../pages/apply/views/apply-list.page.vue'], resolve)

const InterviewListPage = resolve => require(['../pages/interview/views/interview-list.page.vue'], resolve)

const InterviewDetailPage = resolve => require(['../pages/interview/views/interview-detail.page.vue'], resolve)

const InterviewScorePage = resolve => require(['../pages/interview/views/interview-score.page.vue'], resolve)

const AltitudeListPage = resolve => require(['../pages/altitude/views/altitude-list.page.vue'], resolve)

const AltitudeRankListPage = resolve => require(['../pages/altitude/views/altitude-rank-list.page.vue'], resolve)

const PiePage = resolve => require(['../pages/chart/views/pie.page.vue'], resolve)

const ChartPage = resolve => require(['../pages/chart/views/chart.page.vue'], resolve)

const FrameRouter = {}

FrameRouter.routers = [
  {
    path: '/',
    component: FrameIndexPage,
    hidden: true,
    meta: {
      title: 'GASA-ADMIN',
      auth: true,
      access: {
        module: 'frame', page: 'index'
      }
    },
    children: [
      {
        path: '/',
        component: HomePage,
        meta: {
          title: '高山书院后台',
          auth: true,
          access: {
            module: 'Home', page: 'index'
          }
        }
      },
      {
        path: '/change-password',
        component: ChangePwdPage,
        meta: {
          title: '高山书院-修改密码',
          auth: true
        }
      },
      {
        path: '/grade-list',
        component: GradeListPage,
        meta: {
          title: 'GASA-Grade-List',
          auth: true,
          access: {
            module: 'Grade', page: 'list'
          }
        }
      },
      {
        path: '/grade-create',
        component: GradeCreatePage,
        meta: {
          title: 'GASA-Grade-Create',
          auth: true,
          access: {
            module: 'Grade', page: 'create'
          }
        }
      },
      {
        path: '/grade-edit',
        component: GradeEditPage,
        meta: {
          title: 'GASA-Grade-Edit',
          auth: true,
          access: {
            module: 'Grade', page: 'edit'
          }
        }
      },
      {
        path: '/semester-list',
        component: SemesterListPage,
        meta: {
          title: 'GASA-Semester-List',
          auth: true,
          access: {
            module: 'Semester', page: 'list'
          }
        }
      },
      {
        path: '/semester-select-student',
        component: SemesterSelectStudentPage,
        meta: {
          title: 'GASA-select-student',
          auth: true,
          access: {
            module: 'Semester', page: 'select-student'
          }
        }
      },
      {
        path: '/credit-select-student',
        component: CreditSelectStudentPage,
        meta: {
          title: 'GASA-select-student',
          auth: true,
          access: {
            module: 'Credit', page: 'select-student'
          }
        }
      },
      {
        path: '/semester-edit',
        component: SemesterEditPage,
        meta: {
          title: 'GASA-Semester-Edit',
          auth: true,
          access: {
            module: 'Semester', page: 'edit'
          }
        }
      },
      {
        path: '/code-list',
        component: CodeListPage,
        meta: {
          title: 'GASA-Code-List',
          auth: true,
          access: {
            module: 'Code', page: 'list'
          }
        }
      },
      {
        path: '/code-create',
        component: CodeCreatePage,
        meta: {
          title: 'GASA-Code-Create',
          auth: true,
          access: {
            module: 'Code', page: 'create'
          }
        }
      },
      {
        path: '/address-list',
        component: AddressListPage,
        meta: {
          title: 'GASA-Address-List',
          auth: true,
          access: {
            module: 'Address', page: 'list'
          }
        }
      },
      // {
      //   path: '/event-list',
      //   component: EventListPage,
      //   meta: {
      //     title: 'GASA-Event-List',
      //     auth: true,
      //     access: {
      //       module: 'Event', page: 'list'
      //     }
      //   }
      // },
      {
        path: '/test_order',
        component: TestPage,
        meta: {
          title: 'GASA-Event-List',
          auth: true,
          access: {
            module: 'Event', page: 'list'
          }
        }
      },
      {
        path: '/event-reg-list',
        component: EventRegListPage,
        meta: {
          title: 'GASA-Event-Regs-List',
          auth: true,
          access: {
            module: 'Event', page: 'show'
          }
        }
      },
      {
        path: '/export-list',
        component: exporListPage,
        meta: {
          title: 'Export List',
          auth: true,
          access: {
            module: 'export', page: 'list'
          }
        }
      },
      {
        path: '/teacher-list',
        component: TeacherListPage,
        meta: {
          title: 'GASA-Teacher-List',
          auth: true,
          access: {
            module: 'Teacher', page: 'list'
          }
        }
      },
      {
        path: '/teacher-edit',
        component: TeacherEditPage,
        meta: {
          title: 'GASA-Teacher-Edit',
          auth: true,
          access: {
            module: 'Teacher', page: 'edit'
          }
        }
      },
      {
        path: '/course-list',
        component: CourseListPage,
        meta: {
          title: 'GASA-Course-List',
          auth: true,
          access: {
            module: 'Course', page: 'list'
          }
        }
      },
      {
        path: '/course-edit',
        component: CourseEditPage,
        meta: {
          title: 'GASA-Course-Edit',
          auth: true,
          access: {
            module: 'Course', page: 'edit'
          }
        }
      },
      {
        path: '/course-create',
        component: CourseCreatePage,
        meta: {
          title: 'GASA-Course-Create',
          auth: true,
          access: {
            module: 'Course', page: 'create'
          }
        }
      },
      {
        path: '/coursework-list',
        component: CourseWorkListPage,
        meta: {
          title: 'GASA-CourseWork-List',
          auth: true,
          access: {
            module: 'CourseWork', page: 'list'
          }
        }
      },
      {
        path: '/student-list',
        component: StudentListPage,
        meta: {
          title: 'GASA-student-List',
          auth: true,
          access: {
            module: 'Student', page: 'list'
          }
        }
      },
      {
        path: '/staff-list',
        component: StaffListPage,
        meta: {
          title: 'GASA-staff-List',
          auth: true,
          access: {
            module: 'Staff', page: 'list'
          }
        }
      },
      {
        path: '/experiencer-list',
        component: ExperiencerListPage,
        meta: {
          title: 'Experiencer-List',
          auth: true,
          access: {
            module: 'Experiencer', page: 'list'
          }
        }
      },
      {
        path: '/trustee-list',
        component: TrusteeListPage,
        meta: {
          title: 'GASA-trustee-List',
          auth: true,
          access: {
            module: 'Trustee', page: 'list'
          }
        }
      },
      {
        path: '/lecturer-list',
        component: LecturerListPage,
        meta: {
          title: 'GASA-lecturer-List',
          auth: true,
          access: {
            module: 'Lecturer', page: 'list'
          }
        }
      },
      {
        name: 'student-create',
        path: '/student-create',
        component: StudentCreatePage,
        meta: {
          title: 'GASA-student-Create',
          auth: true,
          access: {
            module: 'Student', page: 'create'
          }
        }
      },
      {
        path: '/student-select-course',
        component: StudentSelectCoursePage,
        meta: {
          title: 'GASA-select-course',
          auth: true,
          access: {
            module: 'Student', page: 'select-course'
          }
        }
      },
      {
        path: '/student-show',
        component: StudentShowPage,
        meta: {
          title: 'GASA-student-Show',
          auth: true,
          access: {
            module: 'Student', page: 'show'
          }
        }
      },
      {
        path: '/news-list',
        component: NewsListPage,
        meta: {
          title: 'GASA-News',
          auth: true,
          access: {
            module: 'News', page: 'list'
          }
        }
      },
      {
        path: '/news-create',
        component: NewsCreatePage,
        meta: {
          title: 'GASA-News-Create',
          auth: true,
          access: {
            module: 'News', page: 'create'
          }
        }
      },
      {
        path: '/news-edit',
        component: NewsEditPage,
        meta: {
          title: 'GASA-News-Edit',
          auth: true,
          access: {
            module: 'News', page: 'edit'
          }
        }
      },
      {
        path: '/apply-list',
        component: ApplyListPage,
        meta: {
          title: 'GASA-Altitude-Apply',
          auth: true,
          access: {
            module: 'Apply', page: 'list'
          }
        }
      },
      {
        path: '/interview-list',
        component: InterviewListPage,
        meta: {
          title: 'GASA-Interview-Apply',
          auth: true,
          access: {
            module: 'Interview', page: 'list'
          }
        }
      },
      {
        path: '/interview-detail',
        component: InterviewDetailPage,
        meta: {
          title: 'GASA-interview-detail',
          auth: true,
          access: {
            module: 'Interview', page: 'detail'
          }
        }
      },
      {
        path: '/interview-score',
        component: InterviewScorePage,
        meta: {
          title: 'GASA-interview-score',
          auth: true,
          access: {
            module: 'Interview', page: 'score'
          }
        }
      },
      {
        path: '/altitude-list',
        component: AltitudeListPage,
        meta: {
          title: 'Altitude list',
          auth: true,
          access: {
            module: 'Altitude', page: 'list'
          }
        }
      },
      {
        path: '/altitude-rank-list',
        component: AltitudeRankListPage,
        meta: {
          title: 'Altitude Rank list',
          auth: true,
          access: {
            module: 'Altitude', page: 'list'
          }
        }
      },
      {
        path: '/chart',
        component: ChartPage,
        meta: {
          title: 'chart',
          auth: true,
          access: {
            module: 'Chart', page: 'list'
          }
        }
      },
      {
        path: '/pie',
        component: PiePage,
        meta: {
          title: 'pie',
          auth: true,
          access: {
            module: 'Pie', page: 'list'
          }
        }
      }
    ]
  }
]

export default FrameRouter



// WEBPACK FOOTER //
// ./src/router/pages.router.js